export const pressData = [

 {
    type: "POST",
    date: "16 October 2025",
    title: "UEH's Innovation with Technology class",
    img: "https://saigonai.com/img/ueh_tech_class.jpeg",
    links: [
      {"name": "View on Linked-In", "uri": "https://www.linkedin.com/posts/joyrebecca_entrepreneurship-innovation-aieducation-activity-7388874690385203200--Yeh?utm_source=share&utm_medium=member_desktop&rcm=ACoAAABZ7cIB_5chdkaZiq9oxdEJtHmrSx6EaRM"},
    ]
  },
 {
    type: "VIDEO",
    date: "29 August 2025",
    title: "HackerNoon: Writing, Interneting, and Existing in The Age of AI, with Andrew Schwabe",
    img: "https://img.youtube.com/vi/-SlFLu-fCO4/maxresdefault.jpg",
    links: [
      {"name": "Watch on YouTube", "uri": "https://www.youtube.com/watch?v=-SlFLu-fCO4"},
    ]
  },
 {
    type: "POST",
    date: "20 August 2025",
    title: "Launch JDI: The Future of Artifical Intelligence Chapter 3",
    img: "https://saigonai.com/img/rebecca_jdi_3.jpg",
    links: [
      {"name": "View on Linked-In", "uri": "https://www.linkedin.com/posts/launch-jdi_jdi-launchjdi-tfoai3-activity-7363878384310865925-GmBi?utm_source=share&utm_medium=member_desktop&rcm=ACoAAABZ7cIB_5chdkaZiq9oxdEJtHmrSx6EaRM"},
    ]
  },
  {
    type: "POST",
    date: "19 July 2025",
    title: "TEDxVNUIS 2025: Scarborne, Starborn Showcase",
    img: "https://saigonai.com/img/andrew_tedx.jpg",
    links: [
      {"name": "View on Facebook", "uri": "https://www.facebook.com/share/p/14FpaU2r9u2/"},
    ]
  },  
  {
    type: "POST",
    date: "25 June 2025",
    title: "Engineered Prompting: Precision GenAI Outputs",
    img: "https://saigonai.com/img/june_workshop.jpg",
    links: [
      {"name": "View on Linked-In", "uri": "https://www.linkedin.com/posts/ceecvn_ceecvietnam-aiforbusiness-digitaltransformation-activity-7340664525685211137-_AzL?utm_source=share&utm_medium=member_desktop&rcm=ACoAAABZ7cIB_5chdkaZiq9oxdEJtHmrSx6EaRM"},
    ]
  },
  {
    type: "POST",
    date: "17 June 2025",
    title: "CEEC Business Session: Work Smarter with AI",
    img: "https://saigonai.com/img/andrew_ceec.jpg",
    links: [
      {"name": "View on Linked-In", "uri": "https://www.linkedin.com/posts/ceecvn_ceecvietnam-aiforbusiness-digitaltransformation-activity-7340664525685211137-_AzL?utm_source=share&utm_medium=member_desktop&rcm=ACoAAABZ7cIB_5chdkaZiq9oxdEJtHmrSx6EaRM"},
    ]
  }, 
  {
    type: "POST",
    date: "27 February 2025",
    title: "Organization Readiness for AI",
    img: "https://saigonai.com/img/feb_workshop.jpeg",
    links: [
      {"name": "View on Linked-In", "uri": "https://www.linkedin.com/feed/update/urn:li:activity:7302870471190974464"},
      {"name": "View a particpant review", "uri": "https://www.linkedin.com/feed/update/urn:li:activity:7301034585994235904"},
    ]
  },
  {
    type: "POST",
    date: "2 December 2024",
    title: "RMIT Guest Lecturer: Foundations of AI for STEM",
    img: "https://saigonai.com/img/rmit_stem.jpeg",
    links: [
      {"name": "View on Linked-In", "uri": "https://www.linkedin.com/posts/saigonai_saigon-ai-highlight-sharing-knowledge-activity-7275132724263198722-y8Yj?utm_source=share&utm_medium=member_desktop&rcm=ACoAAABZ7cIB_5chdkaZiq9oxdEJtHmrSx6EaRM"},
    ]
  },
  {
    type: "POST",
    date: "21 November 2024",
    title: "AmCham ESG Impact Recognition",
    img: "https://saigonai.com/img/amcham_impact.jpeg",
    links: [
      {"name": "View on Linked-In", "uri": "https://www.linkedin.com/posts/saigonai_esgexcellence-amchamvietnam-saigonai-activity-7269334494547972096-T26n?utm_source=share&utm_medium=member_desktop&rcm=ACoAAABZ7cIB_5chdkaZiq9oxdEJtHmrSx6EaRM"},
    ]
  }, 
  {
    type: "PODCAST",
    date: "2 October 2024",
    title: "The Disruption Is Now: Innovating with Behavioral Data Science",
    img: "https://img.youtube.com/vi/EZuClHUFhnU/maxresdefault.jpg",
    links: [
      {"name": "Watch Podcast", "uri": "https://www.youtube.com/watch?v=EZuClHUFhnU"},
    ]
  },
  {
    type: "ARTICLE",
    date: "26 September 2024",
    title: "Import and export to the US market: Opportunities and solutions with AI technology",
    img: "https://saigonai.com/img/andrew_supply_chain.jpg",
    links: [
      {"name": "Read Article", "uri": "https://voh.com.vn/thong-tin-doanh-nghiep/xuat-nhap-khau-vao-thi-truong-hoa-ky-co-hoi-va-giai-phap-voi-cong-nghe-ai-553850.html?fbclid=IwZXh0bgNhZW0CMTAAYnJpZBExcDNoOWt3RFBjWGVoNFp5eQEedXznWz_orKQ8pz49L-kXaJEvVafs_V4dln5pLYFUU6kMluj2oG3X1uftqp4_aem_jfg29aw8KSXbPoVyKGvDcw"},
    ]
  },
  {
    type: "PODCAST",
    date: "22 August 2024",
    title: "MMA ALC Summit 2024 | CEO TALK: Stay Ahead with AI",
    img: "https://saigonai.com/img/andrew_MMA.jpg",
    links: [
      {"name": "Watch Podcast", "uri": "https://www.youtube.com/watch?v=E_orbmUeGx4"},
    ]
  },
  {
    type: "POST",
    date: "22 August 2024",
    title: "INNOEX 2024",
    img: "https://saigonai.com/img/innoex_panel.jpg",
    links: [
      {"name": "View on INNOEX", "uri": "https://innoex.vn/team/rebecca-joy/"},
    ]
  },
  {
    type: "POST",
    date: "31 July 2024",
    title: "She Loves Data Vietnam: Forge your career path in DATA and AI",
    img: "https://saigonai.com/img/she_loves_data.jpg",
    links: [
      {"name": "View on She Loves Data", "uri": "https://shelovesdata.com/event/vietnam-forge-your-career-path-in-data-and-ai/"},
    ]
  },
  {
    type: "PODCAST",
    date: "23 July 2024",
    title: "Tectonic Lounge Ep. 11: Demystifying A.I. for Business People with Practical Insights from Andrew Schwabe, Saigon A.I.",
    img: "https://img.youtube.com/vi/6wlYunvuYFc/maxresdefault.jpg",
    links: [
      {"name": "Watch Podcast", "uri": "https://www.youtube.com/watch?v=6wlYunvuYFc"},
      {"name": "Listen on Spotify", "uri": "https://podcasters.spotify.com/pod/show/techtonic-lounge/episodes/E11-Demystifying-A-I--for-Business-People-with-Practical-Insights-from-Andrew-Schwabe--Saigon-AI-e2ma4t8"},
    ]
  },
  {
    type: "POST",
    date: "12 July 2024",
    title: "Launch JDI The Future of Artificial Intelligence: Chapter 2",
    img: "https://saigonai.com/img/jdi_chapter_2.jpg",
    links: [
      {"name": "View on Launch JDI", "uri": "https://jdi.group/event-recap-the-future-of-artificial-intelligence-chapter-2/"},
    ]
  },
  {
    type: "POST",
    date: "28 May 2024",
    title: "FORTEC: Keynote Speaker",
    img: "https://saigonai.com/img/fortec.png",
    links: [
      {"name": "View on Linked-In", "uri": "https://www.linkedin.com/posts/fortec-event_thats-a-wrap-for-fortec-2024-activity-7201553098727673857-CJTB?utm_source=share&utm_medium=member_desktop&rcm=ACoAAABZ7cIB_5chdkaZiq9oxdEJtHmrSx6EaRM"},
    ]
  },
  {
    type: "POST",
    date: "20 April 2024",
    title: "RMIT Guest Lecture: Digital Entrepreneurship",
    img: "https://saigonai.com/img/rmit_guest.jpg",
    links: [
      {"name": "View on Linked-In", "uri": ""},
    ]
  },
  {
      type: "PRESS RELEASE",
      date: "8 March 2024",
      title: "Saigon A.I. Partners with Microsoft Code; Without Barriers to Drive Gender Inclusivity",
      img: "https://www.saigonai.com/img/ms_sgai_2024.jpg",
      links: [
        {"name": "PDF (English)", "uri": "/documents/saigonai_microsoft_press_release_EN.pdf"},
        {"name": "PDF (Tiếng Việt)", "uri": "/documents/saigonai_microsoft_press_release_VN.pdf"},
      ]
    },
    {
        type: "PODCAST",
        date: "17 January 2024",
        title: "Asia Tech Podcast EP 310: Rebecca Schwabe – Founder at Saigon A.I. – Pioneering Data Science and AI Innovation in Vietnam",
        img: "https://www.saigonai.com/img/Rebecca-Schwabe-Website-01.png",
        links: [
          {"name": "Watch Podcast", "uri": "https://asiatechpodcast.com/2024/01/17/4447/"},
        ]
      },
      {
        type: "POST",
        date: "21 November 2023",
        title: "Amcham ESG Awards: Saigon A.I. Recognized for Social Impact",
        img: "https://media.licdn.com/dms/image/D5610AQEaVZ2mOJSgOQ/image-shrink_800/0/1701256225564?e=2147483647&v=beta&t=YzMoUPSq-H_BuLAgla0gXpMyOSrhzx5r6GA2DWhtdAw",
        links: [
          {"name": "View on Linked-In", "uri": "https://www.linkedin.com/posts/saigonai_saigonai-thanksgivingcheers-gratitude-activity-7135585894564036608-qj00"},
        ]
      },
      {
        type: "VIDEO",
        date: "23 September 2023",
        title: "@America Jakarta: Empowering Women in Tech: Breaking Barriers, Building Success",
        img: "https://saigonai.com/img/20230922_atamerica_jakarta.jpg",
        links: [
          {"name": "Watch on YouTube", "uri": "https://www.youtube.com/watch?v=hyx2sZRFHpE"},
        ]
      },
      {
        type: "PODCAST",
        date: "15 August 2022",
        title: "Asia Insurtech EP 181: Andrew Schwabe - People Are Starting to Wake Up and Say 'Service Matters'",
        img: "https://www.saigonai.com/img/AndrewSchwabe.jpg",
        links: [
          {"name": "Watch Podcast", "uri": "https://asiainsurtechpodcast.com/ep-181-andrew-schwabe-founder-chairman-at-formotiv-people-are-starting-to-wake-up-and-say-service-matters/"},
        ]
      },
      {
        type: "ARTICLE",
        date: "21 April 2021",
        title: "YORK.IE: Meet the Women Data Analysts Who Are Smashing Stereotypes in Vietnam",
        img: "https://saigonai.com/img/saigon_ai_team_york_ie.png",
        links: [
          {"name": "Read Article", "uri": "https://fuel.york.ie/news/data-ai/women-data-analysts-smashing-stereotypes-vietnam"},
        ]
      },
      {
        type: "PODCAST",
        date: "26 November 2021",
        title: "FUSE EP.169: Building up an irresistible culture to reach & surpass product-market fit- Andrew Schwabe",
        img: "https://img.youtube.com/vi/SAIinfRphlI/maxresdefault.jpg",
        links: [
          {"name": "Watch Podcast", "uri": "https://www.youtube.com/watch?v=SAIinfRphlI"},
        ]
      },
      {
        type: "ARTICLE",
        date: "8 October 2021",
        title: "Forbes: Design The Next Stages Of Your Business With These Top Technology And AI Innovators",
        img: "https://www.saigonai.com/img/forbes.png",
        links: [
          {"name": "Read Article", "uri": "https://www.forbes.com/sites/rebeccasuhrawardi/2021/10/08/thinking-about-ai-to-grow-your-fashion-or-design-brand-let-these-companies-inspire-you/"},
        ]
      }
    ]